'use client';

import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import useUser from '@alltrails/context/hooks/useUser';

const PostAuthUpsellModal = dynamic(() => import('@alltrails/upsell/components/GenericPostAuthUpsell/PostAuthUpsellModal'), {
  ssr: false
});

/*
  AppleRedirectUpsell displays the post-auth Plus upsell to free (base) users who authenticated with Apple.
  For Apple auth, the user is taken to a separate page, then redirected back to our site.
  When a user returns, the apple_oauth param is included in search params.
 */

const AppleRedirectUpsell = () => {
  const [isOpen, setIsOpen] = useState(false);
  const user = useUser();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    if (searchParams.has('apple_oauth') && user?.subscriptionTier === 'base') {
      setIsOpen(true);
    }
  }, [user]);

  return <>{isOpen && <PostAuthUpsellModal isOpen={isOpen} onCloseRequest={() => setIsOpen(false)} upsellTrigger="Complete Authentication" />}</>;
};

export default AppleRedirectUpsell;
